<dx-popup
  [showTitle]="true"
  [visible]="visible()"
  (onHidden)="visible.set(false)"
  height="80vh"
  width="auto"
  [maxWidth]="'90vw'"
  [resizeEnabled]="true">

  <div *dxTemplate="let _ of 'title'" class="preview-jour-header">
    <div>
      <strong>Fermetures récurrentes à enregistrer</strong>
    </div>
    <div class="preview-jour-actions">
      <yo-button iconClass="fas fa-save" [theme]="ButtonThemeEnum.SAVE"
        [disabled]="!pendingLines().length" (onClick)="save.emit()"
        tooltip="Enregistrer">
      </yo-button>
      <yo-button iconClass="fas fa-times" [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="visible.set(false)" tooltip="Annuler">
      </yo-button>
    </div>
  </div>

  <div class="preview-jour-grid-wrapper">
    <dx-data-grid
      [dataSource]="indexedLines()"
      keyExpr="_idx"
      [showBorders]="true"
      [rowAlternationEnabled]="true"
      [columnAutoWidth]="true"
      height="100%"
      [selectedRowKeys]="selectedKeys()"
      (onSelectionChanged)="onSelectionChanged($event)">
      <dxo-scrolling mode="virtual"></dxo-scrolling>
      <dxo-selection mode="multiple"></dxo-selection>
      <dxi-column dataField="clientLibelle" caption="Client"></dxi-column>
      <dxi-column dataField="pointLivraisonLibelle" caption="Point de livraison"></dxi-column>
      <dxi-column dataField="prestationLibelle" caption="Prestation"></dxi-column>
      <dxi-column dataField="jours" caption="Jours" cellTemplate="joursTemplate"></dxi-column>

      <div *dxTemplate="let cell of 'joursTemplate'">
          {{cell.row.data.jours | jourSemaineList}}
      </div>
    </dx-data-grid>
  </div>

  <div class="custom-button-container-right mg-t-10">
    <yo-button iconClass="fas fa-trash" label="Supprimer la sélection" [theme]="ButtonThemeEnum.DELETE_INNER"
      [disabled]="!selectedKeys().length" (onClick)="deleteSelected()">
    </yo-button>
  </div>
</dx-popup>
